import { FC } from 'react'
import { LoadingScreenOverlay } from '@purepm/portals-ui'

/**
 * Every full-page loading state (auth gate, flag provider, route suspense, login redirect) reuses
 * the shared overlay so the indicator is identical — same PURE logo, same size, same centering in
 * the viewport — across both the resident and owner portals.
 */
const Loading: FC = () => <LoadingScreenOverlay isLoading />

export default Loading
